import React, { useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCalcularTotal } from "./../../../../Shared/Hooks/Custom.hooks";
import "./Resumen.component.scss";

const ResumenComponent = ({
  cotizacion,
  cliente,
  despacho,
  sucursal,
  cerrarCotizacion,
}) => {
  const [productosTotal, setProductos] = useCalcularTotal([]);

  const DatosCliente = () => {
    const { datos } = cliente;
    return (
      <>
        <div className="row mb-3">
          <div className="col-12">
            <h4 className="text-secondary font-weight-bold">
              Datos del cliente
            </h4>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 d-inline-flex pl-4">
            <FontAwesomeIcon
              icon={["fas", "id-card"]}
              className="mr-3 text-black-50"
              size="lg"
            />
            <h5>{datos.Nombre}</h5>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 d-inline-flex pl-4">
            <FontAwesomeIcon
              icon={["fas", "at"]}
              className="mr-3 text-black-50"
              size="lg"
            />
            <h5>{datos.Correo}</h5>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 d-inline-flex pl-4">
            <FontAwesomeIcon
              icon={["fas", "phone"]}
              className="mr-3 text-black-50"
              size="lg"
            />
            <h5>{datos?.Telefono || ""}</h5>
          </div>
        </div>
      </>
    );
  };

  const DatosDespacho = () => {
    const { Tipo = "" } = despacho;

    return (
      <>
        <div className="row mb-3">
          <div className="col-12">
            <h4 className="text-secondary font-weight-bold">
              Datos del despacho
            </h4>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 d-inline-flex pl-4">
            <FontAwesomeIcon
              icon={["fas", "store"]}
              size="lg"
              className="mr-3 text-black-50"
            />
            <h5>{Tipo}</h5>
          </div>
        </div>
      </>
    );
  };

  const DatosProductos = () => {
    return (
      <>
        <div className="row mb-3">
          <div className="col-12">
            <h4 className="text-secondary font-weight-bold">Productos</h4>
          </div>
        </div>
        {productosTotal.map((producto, index) => {
          return (
            <div className="row" key={index}>
              <div className="col-12 d-flex justify-content-between border-bottom mb-2 p-1">
                <h6>{producto.Descripcion}</h6>
                <h6>{producto.Total}</h6>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const DatosSucursal = () => {
    const { datos = {} } = sucursal;
    const { Descripcion = "", Nombre = "" } = datos;

    return (
      <>
        <div className="row">
          <div className="col-12">
            <h4 className="text-secondary font-weight-bold">
              Datos de la sucursal
            </h4>
          </div>
        </div>
        <div className="row pl-4">
          <div className="col-auto">
            <FontAwesomeIcon
              icon={["fas", "map-marked-alt"]}
              size="lg"
              className="mr-3 text-black-50"
            />
          </div>
          <div className="col">
            <h5>{Nombre}</h5>
            <h5>{Descripcion}</h5>
          </div>
        </div>
      </>
    );
  };

  const handleClickCerrarCotizacion = () => {
    cerrarCotizacion();
  };

  useEffect(() => {
    const { datos = {} } = cotizacion;
    const { Productos = [] } = datos;
    setProductos(Productos);
  }, [cotizacion]);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-12">
              <DatosCliente />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <DatosDespacho />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <DatosSucursal />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <DatosProductos />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          {productosTotal.length <= 0 ? (
            <Alert variant="danger">No tiene productos cargados</Alert>
          ) : null}
          {!despacho.Tipo ? (
            <Alert variant="danger">
              Debe escoger un metodo para el despacho
            </Alert>
          ) : null}
          {productosTotal.length > 0 && despacho.Tipo ? (
            <Button
              variant="primary"
              block
              onClick={handleClickCerrarCotizacion}
            >
              Cerrar cotización
            </Button>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ResumenComponent;
